import React, { useState } from 'react';

import { browserHistory } from '@common/helpers/browserHistory';

import { withdrawSearchPlayer, withdrawSuccessState } from '../constants';
import ClientTransactionSearchPlayer from '../components/searchPlayer';
import WithdrawChooseRequest from './chooseRequest';
import WithdrawPayRequest from './payRequest';
import ClientTransactionSuccess from '../components/success';

const ClientTransactionWithdraw = () => {
  const [client, setClient] = useState(null);
  const [request, setRequst] = useState(null);
  const [success, setSuccess] = useState(false);

  if (success) {
    return (
      <ClientTransactionSuccess
        {...withdrawSuccessState}
        onReset={() => browserHistory.push('/clientTransaction')}
      />
    );
  }

  if (!client) {
    return (
      <ClientTransactionSearchPlayer
        {...withdrawSearchPlayer}
        onNext={result => setClient(result.playerInfo)}
      />
    );
  }

  if (!request) {
    return (
      <WithdrawChooseRequest
        client={client}
        onBack={() => setClient(null)}
        onNext={setRequst}
      />
    );
  }

  return (
    <WithdrawPayRequest
      request={request}
      onBack={() => setRequst(null)}
      onNext={() => setSuccess(true)}
    />
  );
};

export default ClientTransactionWithdraw;
